import React, { FC } from 'react'
import { Loader } from 'react-bulma-components'
import styled from 'styled-components'

import { useTheme } from '@/contexts'

type Props = { size?: string; display?: string }

const Container = styled.div<{ display?: string }>`
  height: 100%;
  display: ${({ display }) => display};
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

export const UiLoading: FC<Props> = ({ display = 'flex', size = '300%', children }) => {
  const { theme } = useTheme()
  return (
    <Container display={display}>
      <Loader style={{ fontSize: size, color: theme.color.iconGray }} />
      {children}
    </Container>
  )
}
